import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getInvoice } from "../../utility";
import { BackIcon } from "../../components/Icon";

const InvoiceCanceled = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    const fetchInvoice = async () => {
      const data = await getInvoice(invoiceId);
      if (!data) return;
      setInvoice(data);
    };

    if (invoiceId) {
      fetchInvoice();
    }
  }, [invoiceId]);

  return (
    <div className="main-page">
      <div className="container px-4 d-flex flex-column" style={{ minHeight: "100dvh" }}>
        <div className="page-title">
          <button type="button" className="back-icon" onClick={() => navigate(-1)}>
            <BackIcon />
          </button>
          Invoice
        </div>

        <div className="mt-auto text-center">
          <div className="mt-12 pb-4">La facture {invoice?.id} n'a pas été payée!</div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceCanceled;
